var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_783_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7.99984C9.33333 6.0265 8 3.33317 7.33333 2.6665C7.33333 4.69184 6.15133 5.82717 5.33333 6.6665C4.516 7.5065 4 8.8265 4 9.99984C4 11.0607 4.42143 12.0781 5.17157 12.8283C5.92172 13.5784 6.93913 13.9998 8 13.9998C9.06087 13.9998 10.0783 13.5784 10.8284 12.8283C11.5786 12.0781 12 11.0607 12 9.99984C12 8.9785 11.296 7.37317 10.6667 6.6665C9.476 8.6665 8.806 8.6665 8 7.99984Z",
    stroke: "#222529",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_783_1451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.7c143fc60de298dc2965aca209c24c49.svg";
export { ForwardRef as ReactComponent };